import { useBusinessContext } from '@root/context'
import { useQuery } from '@tanstack/react-query'
import { BusinessIdentifierTypeOption, fetchBusinessIdentifierTypes } from '../businessIdentifiers'

export const useBusinessIdentifierTypes = () => {
  const { slug } = useBusinessContext()

  return useQuery<BusinessIdentifierTypeOption[]>({
    queryKey: [slug, 'businessIdentifierTypes'],
    queryFn: () => fetchBusinessIdentifierTypes({ slug }),
    staleTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(slug)
  })
}
